import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const Overview: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--overview')}
    viewBox="0 0 36 36"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <path
      d="M28 17.5v8H13v-8h15zm-16.5 0v8h-7v-8h7zm15 1.5h-12v5h12v-5zM10 19H6v5h4v-5zm9.5-12v9h-15V7h15zM28 7v9h-7V7h7zM18 8.5H6v6h12v-6zm8.5 0h-4v6h4v-6z"
      fill="#000"
      fillRule="nonzero"
    />
  </svg>
);

export default Overview;
